import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classnames from 'classnames/bind';
import { connect } from 'react-redux';
import Button from 'yoda-core-components/lib/components/Button';
import {
    ACCOUNT_LOCKED_PAGE_MESSAGE,
    ACCOUNT_LOCKED_PAGE_HOME_LINK,
    ACCOUNT_LOCKED_PAGE_TITLE,
    URL_HOME_PAGE,
} from 'yoda-checkout-components/lib/common/Constants';
import CheckoutHeader from 'yoda-checkout-components/lib/components/CheckoutHeader/CheckoutHeader';
import Footer from 'yoda-checkout-components/lib/components/Footer/Footer';
import LiveChat from 'yoda-checkout-components/lib/components/LiveChat/LiveChat';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './AccountLockedPage.css';

const cx = classnames.bind(styles);

export class AccountLockedPage extends Component {
    static propTypes = {
        context: PropTypes.objectOf(PropTypes.object).isRequired,
    };

    constructor() {
        super();
        this.goToHome = this.goToHome.bind(this);
    }

    goToHome = () => {
        window.location.href = URL_HOME_PAGE;
    };

    render() {
        const {
            context: { deviceType },
        } = this.props;
        return (
            <section className={cx('accountLockedWrapper')}>
                <CheckoutHeader deviceType={deviceType} />
                <section
                    className={`${cx('accountLockedBlock')} ${dt(['smOnly:p-0', 'h-full'])}`}
                    data-automation-id="at-acc-locked-block"
                >
                    <article
                        className={`${cx('row', 'rowBlock')} ${dt([
                            'smOnly:left-0',
                            'relative',
                            'h-full',
                            'my-6',
                            'px-6',
                            'mx-auto',
                            'text-black',
                        ])}`}
                    >
                        <section
                            className={`${cx('checkoutContent')} ${dt(['text-center'])}`}
                            data-automation-id="at-checkout-content-wrapper"
                        >
                            <p
                                className={`${cx('col8', 'youAreLoggedOut')} ${dt([
                                    'block',
                                    'text-center',
                                    'font-open-sans-bold',
                                    'text-xlarge',
                                    'mb-2',
                                ])}`}
                                data-automation-id="at-acc-locked-title"
                            >
                                {ACCOUNT_LOCKED_PAGE_TITLE}
                            </p>
                            <p
                                className={`${cx('col12', 'sessionEnded')} ${dt([
                                    'block',
                                    'text-center',
                                    'text-normal',
                                    'mb-10',
                                ])}`}
                                data-automation-id="at-acc-locked-session-ended-msg"
                            >
                                {ACCOUNT_LOCKED_PAGE_MESSAGE}
                            </p>
                            <div
                                className={cx('returnToHomeBtnWrapper`')}
                                data-automation-id="at-return-to-home-wrapper"
                            >
                                <Button
                                    buttonType="Link"
                                    size="Md"
                                    className={cx('returnToHomeBtn')}
                                    automationId="at-returnToHomeBtn"
                                    onClick={this.goToHome}
                                >
                                    {ACCOUNT_LOCKED_PAGE_HOME_LINK}
                                </Button>
                            </div>
                        </section>
                    </article>
                    <LiveChat />
                </section>
                <Footer context={this.props.context} />
            </section>
        );
    }
}

const mapStateToProps = (state) => ({
    context: state.context,
});
export default connect(mapStateToProps, null)(AccountLockedPage);
